export enum DocType {
  BillOfLading = 'BL',
  DeliveryReceipt = 'DR',
  LetterOfAuthority = 'LOA',
  InvoicePdf = 'ARIN',
  WeightInspectionCertificate = 'WI',
  NmfcClassInspectionCertificate = 'NCIC',
  Customs = 'CUST',
}
